import { akaConsent, marketingConsent } from "./consent";

import { combineReducers } from "@reduxjs/toolkit";
import { addProductToCart } from "./addProductToCart/slice";
import { addressSuggestions } from "./addressSuggestions/addressSuggestionsSlice";
import { advice } from "./advice/slice";
import { advicePDF } from "./advicePDF/slice";
import { advisor } from "./advisor/advisorSlice";
import { akaAdvice } from "./akaAdvice/slice";
import { akaHealthConfig } from "./akaHealthConfig/akaHealthConfigSlice";
import { analytics } from "./analytics/analyticsSlice";
import { cart } from "./cart/cartSlice";
import { companies } from "./companies/slice";
import { downtime } from "./downtime/slice";
import { estate } from "./estate/estateSlice";
import { errorDisplayed } from "./eventFailed/errorDisplayedSaga";
import { operationFailedSentry } from "./eventFailed/operationFailedSaga";
import { findAnimalBreed } from "./findAnimalBreed/findAnimalBreedSlice";
import { findVehicle } from "./findVehicle/slice";
import { findVehicleType } from "./findVehicleType/slice";
import { getVeteranVehicleModel } from "./getVeteranVehicleModel/slice";
import { localStorage } from "./localStorage/localStorageSlice";
import { offerAccept } from "./offerAccept/offerAcceptSlice";
import { offer } from "./offerEmail/slice";
import { partner } from "./partners/partnerSlice";
import { postNumber } from "./postNumber/postNumberSlice";
import { priceCalculation } from "./priceCalculation/priceCalculationSlice";
import { stepStatus } from "./steps/stepsSlice";
import { texts } from "./texts/slice";
import { updateHuseierneMembershipStatus } from "./updateHuseierneMembershipStatus/slice";
import { userIdentification } from "./userIdentification";
import { validatedCustomerName } from "./validateCustomerName/slice";
import { validatedLicensePlates } from "./validateLicensePlate/slice";
import { validatedProductNameNin } from "./validateProductNameNin/slice";

const rootReducer = combineReducers({
  actionFailedGA: errorDisplayed,
  addProductToCart,
  addressSuggestions,
  advicePDF,
  advisor,
  advice,
  akaAdvice,
  akaConsent,
  akaHealthConfig,
  analytics,
  cart,
  companies,
  marketingConsent,
  downtime,
  estate,
  findAnimalBreed,
  findVehicle,
  findVehicleType,
  getVeteranVehicleModel,
  localStorage,
  offer,
  offerAccept,
  operationFailedSentry,
  partner,
  postNumber,
  priceCalculation,
  stepStatus,
  texts,
  updateHuseierneMembershipStatus,
  userIdentification,
  validatedCustomerName,
  validatedLicensePlates,
  validatedProductNameNin,
});

export type ReduxState = ReturnType<typeof rootReducer>;
export default rootReducer;
